<template>
    <div>
        <template v-if="payment_preference == true">
            <div class="page-top mb-1 mb-3">
                <h1> Add Virtual Company Payment Preference </h1>
            </div>
            <div class="global-main">
                <form id="paymentPreferenceForm" @submit.prevent="addAllCompanyPaymentPreferenceData">
                    <div class="tab-content-inner">
                      <div class="form-group">
                        <label> IBFT </label>
                        <select v-model="form.IBFT" name="ibft" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('ibft') }">
                          <option value="EMONEY" selected>EMONEY</option>
                          <option value="EASYPAISA">EASYPAISA</option>
                          <option value="FINCA">FINCA</option>
                          <option value="MEEZAN">MEEZAN</option>
                        </select>
                        <has-error :form="form" field="status"></has-error>
                      </div>
                      <div class="form-group">
                        <label> BILL </label>
                        <select v-model="form.BILL" name="bill" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('bill') }">
                          <option value="EMONEY" selected>EMONEY</option>
                          <option value="FINCA">FINCA</option>
                        </select>
                        <has-error :form="form" field="status"></has-error>
                      </div>
                      <div class="form-group">
                        <label> TOPUP </label>
                        <select v-model="form.TOPUP" name="topup" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('topup') }">
                          <option value="EMONEY" selected>EMONEY</option>
                          <option value="FINCA">FINCA</option>
                        </select>
                        <has-error :form="form" field="status"></has-error>
                      </div>
                        <div class="form-group">
                            <label> Status </label>
                            <select v-model="form.status" name="status" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('status') }">
                                <option value="" selected>Select Status</option>
                                <option value="ON">ON</option>
                                <option value="OFF">OFF</option>
                            </select>
                            <has-error :form="form" field="status"></has-error>
                        </div>
                    </div>
                    <div class="form-group">
                        <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                        <router-link to="/paymentPreferenceList" class="btn btn-primary float-right mr-2">Cancel</router-link>
                    </div>
                </form>
            </div>
        </template>
        <template v-else-if="payment_preference === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="payment_preference === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                  IBFT: "",
                    BILL: "",
                    TOPUP: "",
                    status: "",
                }),
                companies: {},
              payment_preference: null,
            };
        },
        methods: {
          addAllCompanyPaymentPreferenceData() {
                this.$Progress.start();
            Swal.fire({
              title: 'Are you sure?',
              text: 'Payment Preference For all companies will be edited!',
              type: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Proceed'
            }).then((result) => {
              if (result.value) {
                this.form
                    .post("api/editAllCompanyPaymentPreference")
                    .then((res) => {
                      if (res.status == 200) {
                        if (res.data.code == 200) {
                          this.$Progress.finish();
                          this.showToastBox("success", "Payment Preference added successfully");
                          this.$router.push("/paymentPreferenceList");
                        } else {
                          this.showToastBox("error", res.data.message);
                        }
                      } else {
                        this.$Progress.fail();
                        this.showAlertBox("error", "Some error in your form data");
                        $(this.$el).find('.selectpicker').selectpicker('refresh');
                      }
                    }).then(res => {
                  $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                    .catch(err => {
                      $(this.$el).find('.selectpicker').selectpicker('refresh');
                      this.$Progress.fail();
                      this.showAlertBox('error','Error to load form data');
                    });
              }else{this.$router.go(this.$router.currentRoute);}
            })
            },
          resetForm() {
            this.form.IBFT = "";
            this.form.BILL = "";
            this.form.TOPUP = "";
            this.form.status = "";
          },
        },
        mounted() {
            this.$Progress.start();
            this.can("payment_preference")
                .then((result) => {
                    this.payment_preference = result.payment_preference;
                  this.$Progress.finish();
                })
                .then((result) => {
                  setTimeout(() => {
                    $('.selectpicker').selectpicker('refresh');
                  }, 1000);
                });

        },
    }
</script>
